import { Action } from 'store/store';
import { ShareUsersState } from './ShareUsersState';

export enum ShareUsersActionType {
    SET_SHARE_USERS = 'SET_SHARE_USERS',
}

export type ShareUsersSetAction = Action<
    ShareUsersActionType.SET_SHARE_USERS,
    ShareUsersState
>;

export const setShareUsers: (users: ShareUsersState) => ShareUsersSetAction = (
    users
) => ({
    type: ShareUsersActionType.SET_SHARE_USERS,
    payload: users,
});

export type ShareUsersAction = ShareUsersSetAction;
